export default "__VITE_ASSET__BcjI1Euh__"